module.exports = __webpack_public_path__ + "img/microservices-eventbridge.8994beab.svg";